var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "creative-spinner-container",
      class: [_vm.size, { inline: _vm.inline }],
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "spinner-box" }, [
      _c("div", { staticClass: "leo-border-1" }, [
        _c("div", { staticClass: "leo-core-1" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "leo-border-2" }, [
        _c("div", { staticClass: "leo-core-2" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }